/* unplugin-vue-components disabled */import script from "./BoardTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./BoardTable.vue?vue&type=script&lang=ts&setup=true"

import "./BoardTable.vue?vue&type=style&index=0&id=4a4db9ae&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4db9ae"]])

export default __exports__